export default __webpack_public_path__ + "static/media/lemon.50047025.jpg";